// extracted by mini-css-extract-plugin
module.exports = {"buttonMain":"TextButton_buttonMain__fA0WO","light":"TextButton_light__7zb5a"};